export const QUERY_KEY_TASK_TEMPLATES_SINGLE_VOYAGES = 'tasks_template_single_voyage'
